function createAddToCartManager() {
  let components = new Map();
  let isInitialized = false;

  const registerComponent = (name, component) => {
    components.set(name, component);
  };

  const init = () => {
    if (isInitialized) return;
    
    bindEvents();
    isInitialized = true;
    document.dispatchEvent(new CustomEvent('addon-manager:ready'));
  };

  const bindEvents = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      const formId = form?.id || '';
      
      if ((formId.includes('product-form') || form.getAttribute('is') === 'product-form') && components.size > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleAddToCart(form);
        return false;
      }
    }, { capture: true });

    document.addEventListener('click', (e) => {
      const submitBtn = e.target.closest('button[type="submit"], [type="submit"]');
      if (submitBtn && submitBtn.closest('buy-buttons, [data-product-form]') && components.size > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const form = submitBtn.closest('form');
        if (form) {
          handleAddToCart(form);
        }
        return false;
      }
    }, { capture: true });
  };

  const handleAddToCart = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;
    
    try {
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
      const mainVariantId = form.querySelector('input[name="id"]')?.value;
      const mainQuantity = form.querySelector('input[name="quantity"]') ? 
                          parseInt(form.querySelector('input[name="quantity"]').value) : 1;
      
      if (!mainVariantId) {
        throw new Error('Main product variant ID not found');
      }
      const items = [
        {
          id: parseInt(mainVariantId),
          quantity: mainQuantity
        }
      ];

      const componentItems = collectAllItems();
      if (componentItems.length > 0) {
        items.push(...componentItems);
      }
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        const result = await response.json();
        await triggerCartUpdate();
        openCartDrawer();
        
      } else {
        const errorText = await response.text();
        throw new Error(`Add to cart failed: ${errorText}`);
      }
    } catch (error) {
      console.error('❌ Error adding to cart:', error);
      showMessage('There was an error adding items to cart. Please try again.', 'error');
    } finally {
      if (button && originalText) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  };

  const collectAllItems = () => {
    const items = [];
    
    for (const [name, component] of components) {
      try {
        if (component && typeof component.getItems === 'function') {
          const componentItems = component.getItems();
          if (componentItems && componentItems.length > 0) {
            items.push(...componentItems);
          }
        }
      } catch (error) {
        console.error(`Error collecting items from ${name}:`, error);
      }
    }
    
    return items;
  };

  const triggerCartUpdate = async () => {
    return new Promise((resolve) => {
      const events = ['cart:updated', 'cart:refresh', 'change:cart'];
      events.forEach(eventName => {
        document.dispatchEvent(new CustomEvent(eventName));
      });

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCount(cart.item_count);
          resolve();
        })
        .catch(() => resolve());
      
      setTimeout(resolve, 500);
    });
  };

  const openCartDrawer = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    
    if (cartDrawer) {
      if (typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      } else {
        const openEvent = new Event('open', { bubbles: true });
        cartDrawer.dispatchEvent(openEvent);
      }
    }
  };

  const updateCartCount = (count) => {
    const countElements = document.querySelectorAll([
      '.cart-count',
      '[class*="cart-count"]',
      '.header__cart-count',
      '.cart-bubble__quantity'
    ].join(','));
    
    countElements.forEach(element => {
      element.textContent = count;
    });
  };

  const showMessage = (message, type = 'info') => {
    console.log(`${type.toUpperCase()}: ${message}`);
  };

  return {
    init,
    registerComponent,
    isInitialized: () => isInitialized
  };
}

window.addToCartManager = createAddToCartManager();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.addToCartManager.init();
  });
} else {
  window.addToCartManager.init();
}